export interface CountryPhoneCode {
    name: string;
    dialCode: string;
    isoCode: string;
    flag: string;
}

// Country phone codes matching the countries available in the system
export const countryPhoneCodes: CountryPhoneCode[] = [
    { name: 'Austria', dialCode: '+43', isoCode: 'AT', flag: '🇦🇹' },
    { name: 'Belgium', dialCode: '+32', isoCode: 'BE', flag: '🇧🇪' },
    { name: 'Bulgaria', dialCode: '+359', isoCode: 'BG', flag: '🇧🇬' },
    { name: 'Croatia', dialCode: '+385', isoCode: 'HR', flag: '🇭🇷' },
    { name: 'Cyprus', dialCode: '+357', isoCode: 'CY', flag: '🇨🇾' },
    { name: 'Czech Republic', dialCode: '+420', isoCode: 'CZ', flag: '🇨🇿' },
    { name: 'Denmark', dialCode: '+45', isoCode: 'DK', flag: '🇩🇰' },
    { name: 'Estonia', dialCode: '+372', isoCode: 'EE', flag: '🇪🇪' },
    { name: 'Finland', dialCode: '+358', isoCode: 'FI', flag: '🇫🇮' },
    { name: 'France', dialCode: '+33', isoCode: 'FR', flag: '🇫🇷' },
    { name: 'Germany', dialCode: '+49', isoCode: 'DE', flag: '🇩🇪' },
    { name: 'Greece', dialCode: '+30', isoCode: 'GR', flag: '🇬🇷' },
    { name: 'Hungary', dialCode: '+36', isoCode: 'HU', flag: '🇭🇺' },
    { name: 'Ireland', dialCode: '+353', isoCode: 'IE', flag: '🇮🇪' },
    { name: 'Italy', dialCode: '+39', isoCode: 'IT', flag: '🇮🇹' },
    { name: 'Latvia', dialCode: '+371', isoCode: 'LV', flag: '🇱🇻' },
    { name: 'Lithuania', dialCode: '+370', isoCode: 'LT', flag: '🇱🇹' },
    { name: 'Luxembourg', dialCode: '+352', isoCode: 'LU', flag: '🇱🇺' },
    { name: 'Malta', dialCode: '+356', isoCode: 'MT', flag: '🇲🇹' },
    { name: 'Netherlands', dialCode: '+31', isoCode: 'NL', flag: '🇳🇱' },
    { name: 'Poland', dialCode: '+48', isoCode: 'PL', flag: '🇵🇱' },
    { name: 'Portugal', dialCode: '+351', isoCode: 'PT', flag: '🇵🇹' },
    { name: 'Romania', dialCode: '+40', isoCode: 'RO', flag: '🇷🇴' },
    { name: 'Slovakia', dialCode: '+421', isoCode: 'SK', flag: '🇸🇰' },
    { name: 'Slovenia', dialCode: '+386', isoCode: 'SI', flag: '🇸🇮' },
    { name: 'Spain', dialCode: '+34', isoCode: 'ES', flag: '🇪🇸' },
    { name: 'Sweden', dialCode: '+46', isoCode: 'SE', flag: '🇸🇪' }
];

export const getCountryByName = (name: string): CountryPhoneCode | undefined => {
    return countryPhoneCodes.find(c => c.name === name);
};

export const getCountryByDialCode = (dialCode: string): CountryPhoneCode | undefined => {
    return countryPhoneCodes.find(c => c.dialCode === dialCode);
};

export const parsePhoneNumber = (phoneNumber: string): { dialCode: string; number: string } | null => {
    if (!phoneNumber) return null;

    // Try to find a matching dial code
    const sortedCodes = [...countryPhoneCodes].sort((a, b) => b.dialCode.length - a.dialCode.length);

    for (const country of sortedCodes) {
        if (phoneNumber.startsWith(country.dialCode)) {
            return {
                dialCode: country.dialCode,
                number: phoneNumber.substring(country.dialCode.length).trim()
            };
        }
    }

    return null;
};
